/**
 * Nothing in the CMS records the condition of a deal, so this is an assumption rather than data:
 * the client confirmed refurbished and second-hand offers are rare enough to treat the catalogue as
 * new. It lives here so there is one place to replace once a real field exists.
 */
export const SCHEMA_ITEM_CONDITION = "https://schema.org/NewCondition";

/** Price as a schema.org decimal string. A missing price yields nothing — 0 would read as free. */
export const toSchemaPrice = (price?: number): string | undefined =>
  typeof price === "number" && Number.isFinite(price) && price > 0 ? price.toFixed(2) : undefined;

/**
 * Stock is a quantity rather than a flag — live values range from 1 to several hundred — so any
 * positive amount means in stock. An unknown level yields no availability rather than a guess.
 */
export const getSchemaAvailability = (stock?: number): string | undefined => {
  if (typeof stock !== "number" || !Number.isFinite(stock)) return undefined;

  return stock > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock";
};
